import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #DATEPICKER
\*------------------------------------ */
/**
 * 1) Calendar popup widget
 */
.cat-c-calendar {
  min-width: calc(var(--size-base-unit) * 40);
  width: var(--cat-c-calendar--width, auto);
  margin-block-start: 0;
  background-color: var(--cat-theme-color-background-default);
  position: relative;
  border-radius: var(--cat-theme-border-radius);
  padding: calc(var(--size-base-unit) * 1);
}

/**
 * Navigation wrapper for previous, next and month sele
 */
.cat-c-calendar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block-end: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 6);
}

/**
 * Displayed Month and Year above calendar dates
 */
.cat-c-calendar__month-selector-button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: inline-flex;
  align-items: center;
  gap: calc(var(--size-base-unit) * 1);
  background: none;
  cursor: pointer;
  border: 0;
  padding: calc(var(--size-base-unit) * 1);
  text-align: center;
  color: var(--cat-theme-color-content-default);
}
.cat-c-calendar__month-selector-button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Down-caret icon next to current month label
 */
.cat-c-calendar__month-selector-button-icon {
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
}

/**
 * Navigation buttons for previous/next month
 */
.cat-c-calendar__nav-btn {
  cursor: pointer;
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  /**
   * When previous/next month is not selectable
   */
}
.cat-c-calendar__nav-btn[disabled], .cat-c-calendar__nav-btn[disabled]:focus, .cat-c-calendar__nav-btn[disabled]:hover {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}

/**
 * Body wrapper for days
 */
.cat-c-calendar__table-container {
  text-align: center;
}

/**
 * Footer container in datepicker
 */
.cat-c-calendar__footer {
  padding: 0 calc(var(--size-base-unit) * 2) calc(var(--size-base-unit) * 2);
}

/**
 * Grid for displaying dates
 */
.cat-c-calendar__table {
  width: 100%;
}
.cat-c-calendar__table .cat-c-calendar__table-cell {
  padding: 0;
}
.cat-c-calendar__table .cat-c-calendar__table-row:last-child .cat-c-calendar__item {
  margin-block-end: 0;
}

/**
 * Grid header row spacing
 */
.cat-c-calendar__header-cell {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  text-transform: uppercase;
  color: var(--cat-theme-color-content-default);
  height: calc(var(--size-base-unit) * 6);
  font-weight: var(--cat-font-weight-bold);
  padding-block-end: calc(var(--size-base-unit) * 1);
}

/**
 * Day buttons on calendar
 */
.cat-c-calendar__item {
  background: none;
  border: 1px solid transparent;
  border-radius: 50%;
  height: calc(var(--size-base-unit) * 5);
  width: calc(var(--size-base-unit) * 5);
  padding: 0;
  margin-block-end: calc(var(--size-base-unit) * 1);
  position: relative;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Hover/Focus styles
   */
  /**
   * Focus states for dates
   */
  /**
   * When day is Today but unavailable to select
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When day is Today and available to select
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When day is available to be selected
   */
  /**
   * Selected
   */
  /**
   * When focus is set to the active selected day
   */
  /**
   * When day is not selectable
   */
}
.cat-c-calendar__item:focus-visible, .cat-c-calendar__item:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-calendar__item:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-calendar__item:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  --cat-theme-offset-focus-ring: 0;
}
.cat-c-calendar__item.is-today:after {
  content: "";
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  background: var(--cat-theme-color-content-disabled);
  border-radius: 50%;
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.125);
  inset-inline-start: calc(50% - (var(--size-base-unit) * 0.5));
}
.cat-c-calendar__item.is-today.is-available:after {
  background: var(--cat-theme-color-background-xstrong);
}
.cat-c-calendar__item.is-available {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
}
.cat-c-calendar__item.is-active, .cat-c-calendar__item.is-available.is-active {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
  /**
   * 1) Change current day dot indicator to knockout text color
   */
}
.cat-c-calendar__item.is-active.is-today:after, .cat-c-calendar__item.is-available.is-active.is-today:after {
  background: var(--cat-theme-color-content-knockout); /* 1 */
}
.cat-c-calendar__item.is-active:focus {
  box-shadow: inset 0 0 0 var(--cat-border-width-md) var(--cat-theme-color-border-strong);
}
.cat-c-calendar__item:disabled, .cat-c-calendar__item:disabled:focus, .cat-c-calendar__item:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
.cat-c-calendar__item.is-active:disabled {
  background-color: var(--cat-theme-color-button-background-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-calendar__item.is-active:hover {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
}

/**
 * Month calendar popup
 */
.cat-c-calendar-month-panel--open {
  min-width: calc(var(--size-base-unit) * 40);
}

.cat-c-calendar__month-selector-popup {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  z-index: 1;
  background: var(--cat-theme-color-background-default);
}
.cat-c-calendar__month-selector-popup::-webkit-scrollbar {
  width: calc(var(--size-base-unit) * 0.5);
}
.cat-c-calendar__month-selector-popup::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: var(--cat-theme-color-background-subtle-hover);
  height: calc(var(--size-base-unit) * 5);
}

/* ------------------------------------*\
    #MONTH SELECTOR
\*------------------------------------ */
.cat-c-month-selector {
  padding: calc(var(--size-base-unit) * 1);
}

.cat-c-month-selector__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cat-c-month-selector__item {
  border-block-end: 1px solid var(--cat-theme-color-border-default);
  padding: calc(var(--size-base-unit) * 1) 0;
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: calc(var(--size-base-unit) * 0.5);
}
.cat-c-month-selector__item:last-of-type {
  border-block-end: none;
}

.cat-c-month-selector__sub-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: calc(var(--size-base-unit) * 0.5);
}

.cat-c-month-selector__year-heading {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-subtle);
  margin: calc(var(--size-base-unit) * 1) 0 0;
}

.cat-c-month-selector__button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  text-transform: uppercase;
  font-weight: var(--cat-font-weight-bold);
  background: none;
  border: 1px solid transparent;
  border-radius: 50%;
  min-height: calc(var(--size-base-unit) * 5);
  min-width: calc(var(--size-base-unit) * 5);
  padding: 0;
  position: relative;
  cursor: pointer;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  color: var(--cat-theme-color-content-strong);
  /**
   * Hover/Focus styles
   */
  /**
   * Focus states for dates
   */
  /**
   * When month is current month
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When month is current month but disabled
   * 1) Display a disabled dot underneath the date to indicate the present day
   */
  /**
   * Selected
   */
  /**
   * When month is not selectable
   */
  /**
   * When month is active and not selectable
   */
}
.cat-c-month-selector__button abbr {
  border-block-end: 0;
  text-decoration: none;
}
.cat-c-month-selector__button:focus-visible, .cat-c-month-selector__button:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-month-selector__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-month-selector__button.is-current:after {
  content: "";
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  background: var(--cat-theme-color-background-xstrong);
  border-radius: 50%;
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.125);
  inset-inline-start: calc(50% - (var(--size-base-unit) * 0.5));
}
.cat-c-month-selector__button.is-current:disabled:after {
  background: var(--cat-theme-color-content-disabled);
}
.cat-c-month-selector__button.is-active, .cat-c-month-selector__button.is-available.is-active {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
  /**
   * 1) Change current day dot indicator to knockout text color
   */
}
.cat-c-month-selector__button.is-active.is-current:after, .cat-c-month-selector__button.is-available.is-active.is-current:after {
  background: var(--cat-theme-color-content-knockout); /* 1 */
}
.cat-c-month-selector__button:disabled, .cat-c-month-selector__button:disabled:focus, .cat-c-month-selector__button:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
.cat-c-month-selector__button.is-active:disabled {
  background: var(--cat-theme-color-button-background-disabled);
}
`;
